<template>
  <div class="supervisor-detail">
    <div class="detail-header">
      <h2>
        {{supervisorModel.name}}
      </h2>
    </div>
    <div class="detail-body">
      <Tabs type="card" class="tab-square" :animated="false" v-if="supervisorModel&&supervisorModel.name" v-model="curTab">
        <TabPane label="基本信息" name="basic">
          <table class="brief-table">
            <tbody>
              <tr>
                <td class="title">监管人名称</td>
                <td>{{supervisorModel.name}}</td>
              </tr>
              <tr>
                <td class="title">社会信用代码</td>
                <td>{{supervisorModel.businessLicense}}</td>
              </tr>
              <tr>
                <td class="title">法定代表人</td>
                <td>{{supervisorModel.legalPerson}}</td>
              </tr>
              <tr>
                <td class="title">联系人</td>
                <td>{{supervisorModel.contact}}</td>
              </tr>
              <tr>
                <td class="title">电话</td>
                <td>{{supervisorModel.contactTel}}</td>
              </tr>
              <tr>
                <td class="title">预审保证人</td>
                <td>
                  <i-switch v-model="supervisorRegionPermissions.canPreauditGuarantor" size="large" @on-change="editSupervisorRegion">
                    <Icon type="md-checkmark" slot="open"></Icon>
                    <Icon type="md-close" slot="close"></Icon>
                  </i-switch>
                </td>
              </tr>
              <tr>
                <td class="title">审核保证人</td>
                <td>
                  <i-switch v-model="supervisorRegionPermissions.canAuditGuarantor" size="large" @on-change="editSupervisorRegion">
                    <Icon type="md-checkmark" slot="open"></Icon>
                    <Icon type="md-close" slot="close"></Icon>
                  </i-switch>
                </td>
              </tr>
              <tr>
                <td class="title">设置黑名单</td>
                <td>
                  <i-switch v-model="supervisorRegionPermissions.canBlacklistGuarantor" size="large" @on-change="editSupervisorRegion">
                    <Icon type="md-checkmark" slot="open"></Icon>
                    <Icon type="md-close" slot="close"></Icon>
                  </i-switch>
                </td>
              </tr>
              <tr>
                <td class="title">发起代偿</td>
                <td>
                  <i-switch v-model="supervisorRegionPermissions.canClaim" size="large" @on-change="editSupervisorRegion">
                    <Icon type="md-checkmark" slot="open"></Icon>
                    <Icon type="md-close" slot="close"></Icon>
                  </i-switch>
                </td>
              </tr>
              <tr>
                <td class="title">新增缴纳通知书</td>
                <td>
                  <i-switch v-model="supervisorRegionPermissions.canAddProjectRegister" size="large" @on-change="editSupervisorRegion">
                    <Icon type="md-checkmark" slot="open"></Icon>
                    <Icon type="md-close" slot="close"></Icon>
                  </i-switch>
                </td>
              </tr>
              <tr>
                <td class="title">审核缴纳通知书</td>
                <td>
                  <i-switch v-model="supervisorRegionPermissions.canAuditProjectRegister" size="large" @on-change="editSupervisorRegion">
                    <Icon type="md-checkmark" slot="open"></Icon>
                    <Icon type="md-close" slot="close"></Icon>
                  </i-switch>
                </td>
              </tr>
              <tr v-if="supervisorRegionPermissions.canAddProjectRegister||supervisorRegionPermissions.canAuditProjectRegister">
                <td class="title">缴纳通知书模式</td>
                <td>
                  <Input v-model="supervisorRegionPermissions.projectRegisterMode" style="width:240px;marginRight:10px" placeholder="缴纳通知书模式" />
                  <Button type="primary" ghost @click="editSupervisorRegion">更新</Button>
                </td>
              </tr>
            </tbody>
          </table>
        </TabPane>
        <TabPane label="监管行业/领域" name="industry" v-if="supervisorModel.industries">
          <Form ref="newIndustryForm" :model="newIndustryModel" inline>
            <FormItem prop="industryId" :rules="[{required:true,type:'number',message:'请选择行业/领域',trigger:'blur'}]">
              <Select v-model="newIndustryModel.industryId" filterable :transfer="true" placeholder="选择专属行业/领域">
                <Option v-for="item in industries" :value="item.value" :key="item.value">{{ item.label }}</Option>
              </Select>
            </FormItem>
            <FormItem prop="readOnly">
              <i-switch v-model="newIndustryModel.readOnly" :true-value="false" :false-value="true" size="large">
                <span slot="close">只看</span>
                <span slot="open">管理</span>
              </i-switch>
            </FormItem>
            <FormItem>
              <Button type="primary" @click="addIndustry">增加</Button>
            </FormItem>
          </Form>
          <Table border ref="dataTable"
            size="small"
            stripe
            :columns="industryColumns"
            :data="industryList">
          </Table>
        </TabPane>
        <TabPane label="监管区域" name="city" v-if="supervisorModel.cities">
          <Form ref="newCityForm" :model="newCityModel" inline>
            <FormItem prop="cityId" :rules="[{required:true,type:'number',message:'请选择行业/领域',trigger:'blur'}]">
              <Cascader :data="cities" :load-data="loadCityData" @on-change="citySelected" placeholder="选择" :transfer="true"></Cascader>
            </FormItem>
            <FormItem prop="readOnly">
              <i-switch v-model="newCityModel.readOnly" :true-value="false" :false-value="true" size="large">
                <span slot="close">只看</span>
                <span slot="open">管理</span>
              </i-switch>
            </FormItem>
            <FormItem>
              <Button type="primary" @click="addCity">增加</Button>
            </FormItem>
          </Form>
          <Table border ref="dataTable"
            size="small"
            stripe
            :columns="cityColumns"
            :data="cityList">
          </Table>
        </TabPane>
        <TabPane label="用户管理" name="user" v-if="supervisorModel.users">
          <Form ref="newUserForm" :model="newUserModel" inline>
            <FormItem prop="userId" :rules="[{required:true,message:'请选择用户',trigger:'blur'}]">
              <Select v-model="newUserModel.userId" filterable :transfer="true" placeholder="选择用户">
                <Option v-for="item in users" :value="item.value" :key="item.value">{{ item.label }}</Option>
              </Select>
            </FormItem>
            <FormItem prop="isAdmin">
              <i-switch v-model="newUserModel.isAdmin" size="large">
                <span slot="open">管理员</span>
                <span slot="close">普通</span>
              </i-switch>
            </FormItem>
            <FormItem>
              <Button type="primary" @click="addUser">增加</Button>
            </FormItem>
          </Form>
          <Table border ref="dataTable"
            size="small"
            stripe
            :columns="userColumns"
            :data="userList">
          </Table>
        </TabPane>
      </Tabs>
    </div>
  </div>
</template>

<script>
import Api from './../../api/Api.js'
export default {
  name: 'supervisor-detail',
  props: {
  },
  data () {
    return {
      loading: false,
      curTab: '',
      supervisorModel: {
        id: null,
        name: null,
        businessLicense: null,
        legalPerson: null,
        contact: null,
        contactTel: null
      },
      supervisorRegionPermissions: {
        canPreauditGuarantor: false,
        canAuditGuarantor: false,
        canBlacklistGuarantor: false,
        canClaim: false,
        canAddProjectRegister: false,
        canAuditProjectRegister: false,
        projectRegisterMode: null
      },
      industryColumns: [
        {
          title: '名称',
          key: 'name',
          resizable: true,
          sortable: true,
          sortMethod: (a, b, type) => {
            if (type === 'asc') {
              return a.localeCompare(b, 'zh-CN')
            } else {
              return b.localeCompare(a, 'zh-CN')
            }
          }
        },
        {
          title: '只能看',
          key: 'readOnly',
          render: (h, params) => {
            return h('i-switch', {
              props: {
                value: !params.row.readOnly,
                size: 'large',
                'before-change': () => {
                  return new Promise((resolve, reject) => {
                    let curVal = !params.row.readOnly
                    this.editIndustryModel = {
                      supervisorId: this.$route.params.supervisorId,
                      industryId: params.row.industry.id,
                      readOnly: curVal,
                      canPreAudit: false,
                      canAudit: false,
                      canAuditTerminate: false,
                      canAuditRenewal: false,
                      canClaim: false,
                      canAddProjectRegister: null,
                      canAuditProjectRegister: null
                    }
                    this.editIndustry().then(() => {
                      resolve()
                    }).catch(() => {
                      reject()
                    })
                  })
                }
              }
            }, [
              h('span', {slot: 'close'}, '只看'),
              h('span', {slot: 'open'}, '管理')
            ])
          }
        },
        {
          title: '预审保函',
          key: 'canPreAudit',
          render: (h, params) => {
            return h('i-switch', {
              props: {
                value: params.row.canPreAudit,
                disabled: params.row.readOnly,
                'before-change': () => {
                  return new Promise((resolve, reject) => {
                    let curVal = params.row.canPreAudit
                    this.editIndustryModel = {
                      supervisorId: this.$route.params.supervisorId,
                      industryId: params.row.industry.id,
                      readOnly: null,
                      canPreAudit: !curVal,
                      canAudit: null,
                      canAuditTerminate: null,
                      canAuditRenewal: null,
                      canClaim: null,
                      canAddProjectRegister: null,
                      canAuditProjectRegister: null
                    }
                    this.editIndustry().then(() => {
                      resolve()
                    }).catch(() => {
                      reject()
                    })
                  })
                }
              }
            }, [
              h('Icon', {
                props: {
                  type: 'md-checkmark'
                },
                slot: 'open'
              }),
              h('Icon', {
                props: {
                  type: 'md-close'
                },
                slot: 'close'
              })
            ])
          }
        },
        {
          title: '审核保函',
          key: 'canAudit',
          render: (h, params) => {
            return h('i-switch', {
              props: {
                value: params.row.canAudit,
                disabled: params.row.readOnly,
                'before-change': () => {
                  return new Promise((resolve, reject) => {
                    let curVal = params.row.canAudit
                    this.editIndustryModel = {
                      supervisorId: this.$route.params.supervisorId,
                      industryId: params.row.industry.id,
                      readOnly: null,
                      canPreAudit: null,
                      canAudit: !curVal,
                      canAuditTerminate: null,
                      canAuditRenewal: null,
                      canClaim: null,
                      canAddProjectRegister: null,
                      canAuditProjectRegister: null
                    }
                    this.editIndustry().then(() => {
                      resolve()
                    }).catch(() => {
                      reject()
                    })
                  })
                }
              }
            }, [
              h('Icon', {
                props: {
                  type: 'md-checkmark'
                },
                slot: 'open'
              }),
              h('Icon', {
                props: {
                  type: 'md-close'
                },
                slot: 'close'
              })
            ])
          }
        },
        {
          title: '审核解除保函',
          key: 'canAuditTerminate',
          render: (h, params) => {
            return h('i-switch', {
              props: {
                value: params.row.canAuditTerminate,
                disabled: params.row.readOnly,
                'before-change': () => {
                  return new Promise((resolve, reject) => {
                    let curVal = params.row.canAuditTerminate
                    this.editIndustryModel = {
                      supervisorId: this.$route.params.supervisorId,
                      industryId: params.row.industry.id,
                      readOnly: null,
                      canPreAudit: null,
                      canAudit: null,
                      canAuditTerminate: !curVal,
                      canAuditRenewal: null,
                      canClaim: null,
                      canAddProjectRegister: null,
                      canAuditProjectRegister: null
                    }
                    this.editIndustry().then(() => {
                      resolve()
                    }).catch(() => {
                      reject()
                    })
                  })
                }
              }
            }, [
              h('Icon', {
                props: {
                  type: 'md-checkmark'
                },
                slot: 'open'
              }),
              h('Icon', {
                props: {
                  type: 'md-close'
                },
                slot: 'close'
              })
            ])
          }
        },
        {
          title: '审核续保',
          key: 'canAuditRenewal',
          render: (h, params) => {
            return h('i-switch', {
              props: {
                value: params.row.canAuditRenewal,
                disabled: params.row.readOnly,
                'before-change': () => {
                  return new Promise((resolve, reject) => {
                    let curVal = params.row.canAuditRenewal
                    this.editIndustryModel = {
                      supervisorId: this.$route.params.supervisorId,
                      industryId: params.row.industry.id,
                      readOnly: null,
                      canPreAudit: null,
                      canAudit: null,
                      canAuditTerminate: null,
                      canAuditRenewal: !curVal,
                      canClaim: null,
                      canAddProjectRegister: null,
                      canAuditProjectRegister: null
                    }
                    this.editIndustry().then(() => {
                      resolve()
                    }).catch(() => {
                      reject()
                    })
                  })
                }
              }
            }, [
              h('Icon', {
                props: {
                  type: 'md-checkmark'
                },
                slot: 'open'
              }),
              h('Icon', {
                props: {
                  type: 'md-close'
                },
                slot: 'close'
              })
            ])
          }
        },
        {
          title: '发起代偿',
          key: 'canClaim',
          render: (h, params) => {
            return h('i-switch', {
              props: {
                value: params.row.canClaim,
                disabled: params.row.readOnly,
                'before-change': () => {
                  return new Promise((resolve, reject) => {
                    let curVal = params.row.canClaim
                    this.editIndustryModel = {
                      supervisorId: this.$route.params.supervisorId,
                      industryId: params.row.industry.id,
                      readOnly: null,
                      canPreAudit: null,
                      canAudit: null,
                      canAuditTerminate: null,
                      canAuditRenewal: null,
                      canClaim: !curVal,
                      canAddProjectRegister: null,
                      canAuditProjectRegister: null
                    }
                    this.editIndustry().then(() => {
                      resolve()
                    }).catch(() => {
                      reject()
                    })
                  })
                }
              }
            }, [
              h('Icon', {
                props: {
                  type: 'md-checkmark'
                },
                slot: 'open'
              }),
              h('Icon', {
                props: {
                  type: 'md-close'
                },
                slot: 'close'
              })
            ])
          }
        },
        {
          title: '新增缴纳通知书',
          key: 'canAddProjectRegister',
          render: (h, params) => {
            return h('i-switch', {
              props: {
                value: params.row.canAddProjectRegister,
                disabled: params.row.readOnly,
                'before-change': () => {
                  return new Promise((resolve, reject) => {
                    let curVal = params.row.canAddProjectRegister
                    this.editIndustryModel = {
                      supervisorId: this.$route.params.supervisorId,
                      industryId: params.row.industry.id,
                      readOnly: null,
                      canPreAudit: null,
                      canAudit: null,
                      canAuditTerminate: null,
                      canAuditRenewal: null,
                      canClaim: null,
                      canAddProjectRegister: !curVal,
                      canAuditProjectRegister: null
                    }
                    this.editIndustry().then(() => {
                      resolve()
                    }).catch(() => {
                      reject()
                    })
                  })
                }
              }
            }, [
              h('Icon', {
                props: {
                  type: 'md-checkmark'
                },
                slot: 'open'
              }),
              h('Icon', {
                props: {
                  type: 'md-close'
                },
                slot: 'close'
              })
            ])
          }
        },
        {
          title: '审核缴纳通知书',
          key: 'canAuditProjectRegister',
          render: (h, params) => {
            return h('i-switch', {
              props: {
                value: params.row.canAuditProjectRegister,
                disabled: params.row.readOnly,
                'before-change': () => {
                  return new Promise((resolve, reject) => {
                    let curVal = params.row.canAuditProjectRegister
                    this.editIndustryModel = {
                      supervisorId: this.$route.params.supervisorId,
                      industryId: params.row.industry.id,
                      readOnly: null,
                      canPreAudit: null,
                      canAudit: null,
                      canAuditTerminate: null,
                      canAuditRenewal: null,
                      canClaim: null,
                      canAddProjectRegister: null,
                      canAuditProjectRegister: !curVal
                    }
                    this.editIndustry().then(() => {
                      resolve()
                    }).catch(() => {
                      reject()
                    })
                  })
                }
              }
            }, [
              h('Icon', {
                props: {
                  type: 'md-checkmark'
                },
                slot: 'open'
              }),
              h('Icon', {
                props: {
                  type: 'md-close'
                },
                slot: 'close'
              })
            ])
          }
        },
        {
          title: '操作',
          render: (h, params) => {
            return h('span', null, [
              h('Tooltip', {
                props: {
                  content: '删除',
                  transfer: true
                }
              }, [
                h('Button', {
                  props: {
                    type: 'error',
                    ghost: true,
                    shape: 'circle',
                    icon: 'ios-trash-outline'
                  },
                  on: {
                    click: () => {
                      let tid = params.row.id
                      this.removeIndustry(tid)
                    }
                  }
                }, null)
              ])
            ])
          }
        }
      ],
      newIndustryModel: {
        supervisorId: this.$route.params.supervisorId,
        industryId: null,
        readOnly: false,
        canPreAudit: false,
        canAudit: false,
        canAuditTerminate: false,
        canAuditRenewal: false,
        canClaim: null,
        canAddProjectRegister: false,
        canAuditProjectRegister: false
      },
      editIndustryModel: {
        supervisorId: this.$route.params.supervisorId,
        industryId: null,
        readOnly: null,
        canPreAudit: null,
        canAudit: null,
        canAuditTerminate: null,
        canAuditRenewal: null,
        canClaim: null,
        canAddProjectRegister: null,
        canAuditProjectRegister: null
      },
      industryList: [],
      industries: [],
      cityColumns: [
        {
          title: '名称',
          key: 'name',
          resizable: true,
          sortable: true,
          sortMethod: (a, b, type) => {
            if (type === 'asc') {
              return a.localeCompare(b, 'zh-CN')
            } else {
              return b.localeCompare(a, 'zh-CN')
            }
          }
        },
        {
          title: '管理',
          key: 'readOnly',
          render: (h, params) => {
            return h('i-switch', {
              props: {
                value: !params.row.readOnly,
                size: 'large',
                'before-change': () => {
                  return new Promise((resolve, reject) => {
                    let curVal = !params.row.readOnly
                    this.editCityModel = {
                      supervisorId: this.$route.params.supervisorId,
                      cityId: params.row.city.tid,
                      readOnly: curVal,
                      canPreAudit: false,
                      canAudit: false,
                      canAuditTerminate: false,
                      canAuditRenewal: false,
                      canAddProjectRegister: null,
                      canAuditProjectRegister: null
                    }
                    this.editCity().then(() => {
                      resolve()
                    }).catch(() => {
                      reject()
                    })
                  })
                }
              }
            }, [
              h('span', {slot: 'close'}, '只看'),
              h('span', {slot: 'open'}, '管理')
            ])
          }
        },
        {
          title: '预审保函',
          key: 'canPreAudit',
          render: (h, params) => {
            return h('i-switch', {
              props: {
                value: params.row.canPreAudit,
                disabled: params.row.readOnly,
                'before-change': () => {
                  return new Promise((resolve, reject) => {
                    let curVal = params.row.canPreAudit
                    this.editCityModel = {
                      supervisorId: this.$route.params.supervisorId,
                      cityId: params.row.city.tid,
                      readOnly: null,
                      canPreAudit: !curVal,
                      canAudit: null,
                      canAuditTerminate: null,
                      canAuditRenewal: null,
                      canAddProjectRegister: null,
                      canAuditProjectRegister: null
                    }
                    this.editCity().then(() => {
                      resolve()
                    }).catch(() => {
                      reject()
                    })
                  })
                }
              }
            }, [
              h('Icon', {
                props: {
                  type: 'md-checkmark'
                },
                slot: 'open'
              }),
              h('Icon', {
                props: {
                  type: 'md-close'
                },
                slot: 'close'
              })
            ])
          }
        },
        {
          title: '审核保函',
          key: 'canAudit',
          render: (h, params) => {
            return h('i-switch', {
              props: {
                value: params.row.canAudit,
                disabled: params.row.readOnly,
                'before-change': () => {
                  return new Promise((resolve, reject) => {
                    let curVal = params.row.canAudit
                    this.editCityModel = {
                      supervisorId: this.$route.params.supervisorId,
                      cityId: params.row.city.tid,
                      readOnly: null,
                      canPreAudit: null,
                      canAudit: !curVal,
                      canAuditTerminate: null,
                      canAuditRenewal: null,
                      canAddProjectRegister: null,
                      canAuditProjectRegister: null
                    }
                    this.editCity().then(() => {
                      resolve()
                    }).catch(() => {
                      reject()
                    })
                  })
                }
              }
            }, [
              h('Icon', {
                props: {
                  type: 'md-checkmark'
                },
                slot: 'open'
              }),
              h('Icon', {
                props: {
                  type: 'md-close'
                },
                slot: 'close'
              })
            ])
          }
        },
        {
          title: '审核解除保函',
          key: 'canAuditTerminate',
          render: (h, params) => {
            return h('i-switch', {
              props: {
                value: params.row.canAuditTerminate,
                disabled: params.row.readOnly,
                'before-change': () => {
                  return new Promise((resolve, reject) => {
                    let curVal = params.row.canAuditTerminate
                    this.editCityModel = {
                      supervisorId: this.$route.params.supervisorId,
                      cityId: params.row.city.tid,
                      readOnly: null,
                      canPreAudit: null,
                      canAudit: null,
                      canAuditTerminate: !curVal,
                      canAuditRenewal: null,
                      canAddProjectRegister: null,
                      canAuditProjectRegister: null
                    }
                    this.editCity().then(() => {
                      resolve()
                    }).catch(() => {
                      reject()
                    })
                  })
                }
              }
            }, [
              h('Icon', {
                props: {
                  type: 'md-checkmark'
                },
                slot: 'open'
              }),
              h('Icon', {
                props: {
                  type: 'md-close'
                },
                slot: 'close'
              })
            ])
          }
        },
        {
          title: '审核续保',
          key: 'canAuditRenewal',
          render: (h, params) => {
            return h('i-switch', {
              props: {
                value: params.row.canAuditRenewal,
                disabled: params.row.readOnly,
                'before-change': () => {
                  return new Promise((resolve, reject) => {
                    let curVal = params.row.canAuditRenewal
                    this.editCityModel = {
                      supervisorId: this.$route.params.supervisorId,
                      cityId: params.row.city.tid,
                      readOnly: null,
                      canPreAudit: null,
                      canAudit: null,
                      canAuditTerminate: null,
                      canAuditRenewal: !curVal,
                      canAddProjectRegister: null,
                      canAuditProjectRegister: null
                    }
                    this.editCity().then(() => {
                      resolve()
                    }).catch(() => {
                      reject()
                    })
                  })
                }
              }
            }, [
              h('Icon', {
                props: {
                  type: 'md-checkmark'
                },
                slot: 'open'
              }),
              h('Icon', {
                props: {
                  type: 'md-close'
                },
                slot: 'close'
              })
            ])
          }
        },
        {
          title: '新增缴纳通知书',
          key: 'canAddProjectRegister',
          render: (h, params) => {
            return h('i-switch', {
              props: {
                value: params.row.canAddProjectRegister,
                disabled: params.row.readOnly,
                'before-change': () => {
                  return new Promise((resolve, reject) => {
                    let curVal = params.row.canAddProjectRegister
                    this.editCityModel = {
                      supervisorId: this.$route.params.supervisorId,
                      cityId: params.row.city.tid,
                      readOnly: null,
                      canPreAudit: null,
                      canAudit: null,
                      canAuditTerminate: null,
                      canAuditRenewal: null,
                      canClaim: null,
                      canAddProjectRegister: !curVal,
                      canAuditProjectRegister: null
                    }
                    this.editCity().then(() => {
                      resolve()
                    }).catch(() => {
                      reject()
                    })
                  })
                }
              }
            }, [
              h('Icon', {
                props: {
                  type: 'md-checkmark'
                },
                slot: 'open'
              }),
              h('Icon', {
                props: {
                  type: 'md-close'
                },
                slot: 'close'
              })
            ])
          }
        },
        {
          title: '审核缴纳通知书',
          key: 'canAuditProjectRegister',
          render: (h, params) => {
            return h('i-switch', {
              props: {
                value: params.row.canAuditProjectRegister,
                disabled: params.row.readOnly,
                'before-change': () => {
                  return new Promise((resolve, reject) => {
                    let curVal = params.row.canAuditProjectRegister
                    this.editCityModel = {
                      supervisorId: this.$route.params.supervisorId,
                      cityId: params.row.city.tid,
                      readOnly: null,
                      canPreAudit: null,
                      canAudit: null,
                      canAuditTerminate: null,
                      canAuditRenewal: null,
                      canClaim: null,
                      canAddProjectRegister: null,
                      canAuditProjectRegister: !curVal
                    }
                    this.editCity().then(() => {
                      resolve()
                    }).catch(() => {
                      reject()
                    })
                  })
                }
              }
            }, [
              h('Icon', {
                props: {
                  type: 'md-checkmark'
                },
                slot: 'open'
              }),
              h('Icon', {
                props: {
                  type: 'md-close'
                },
                slot: 'close'
              })
            ])
          }
        },
        {
          title: '操作',
          render: (h, params) => {
            return h('span', null, [
              h('Tooltip', {
                props: {
                  content: '删除',
                  transfer: true
                }
              }, [
                h('Button', {
                  props: {
                    type: 'error',
                    ghost: true,
                    shape: 'circle',
                    icon: 'ios-trash-outline'
                  },
                  on: {
                    click: () => {
                      let tid = params.row.id
                      this.removeCity(tid)
                    }
                  }
                }, null)
              ])
            ])
          }
        }
      ],
      newCityModel: {
        supervisorId: this.$route.params.supervisorId,
        cityId: null,
        readOnly: false,
        canPreAudit: false,
        canAudit: false,
        canAuditTerminate: false,
        canAuditRenewal: false,
        canClaim: null,
        canAddProjectRegister: false,
        canAuditProjectRegister: false
      },
      editCityModel: {
        supervisorId: this.$route.params.supervisorId,
        cityId: null,
        readOnly: null,
        canPreAudit: null,
        canAudit: null,
        canAuditTerminate: null,
        canAuditRenewal: null,
        canClaim: null,
        canAddProjectRegister: null,
        canAuditProjectRegister: null
      },
      cityList: [],
      cities: [],
      userList: [],
      userColumns: [
        {
          title: '名称',
          key: 'name',
          resizable: true,
          sortable: true,
          sortMethod: (a, b, type) => {
            if (type === 'asc') {
              return a.localeCompare(b, 'zh-CN')
            } else {
              return b.localeCompare(a, 'zh-CN')
            }
          }
        },
        {
          title: '账号',
          key: 'user',
          resizable: true,
          sortable: true,
          sortMethod: (a, b, type) => {
            if (type === 'asc') {
              return a.localeCompare(b, 'zh-CN')
            } else {
              return b.localeCompare(a, 'zh-CN')
            }
          },
          render: (h, params) => {
            return h('span', {}, params.row.user.loginName) 
          }
        },
        {
          title: '最后登录',
          key: 'user',
          resizable: true,
          sortable: true,
          sortMethod: (a, b, type) => {
            if (type === 'asc') {
              return a.localeCompare(b, 'zh-CN')
            } else {
              return b.localeCompare(a, 'zh-CN')
            }
          },
          render: (h, params) => {
            return h('span', {}, params.row.user.lastLoginTime) 
          }
        },
        {
          title: '管理员',
          key: 'isAdmin',
          width: 100,
          sortable: 'custom',
          render: (h, params) => {
            return h('Tag', {
              props: {
                // type: 'dot',
                color: !params.row.isAdmin ? 'default' : 'primary'
              }
            }, !params.row.isAdmin ? '否' : '是')
          }
        },
        {
          title: '操作',
          render: (h, params) => {
            return h('span', null, [
              h('Tooltip', {
                props: {
                  content: '删除',
                  transfer: true
                }
              }, [
                h('Button', {
                  props: {
                    type: 'error',
                    ghost: true,
                    shape: 'circle',
                    icon: 'ios-trash-outline'
                  },
                  on: {
                    click: () => {
                      let userid = params.row.user.id
                      this.removeUser(userid)
                    }
                  }
                }, null)
              ])
            ])
          }
        }
      ],
      newUserModel: {
        supervisorId: this.$route.params.supervisorId,
        userId: null,
        isAdmin: true
      },
      users: []
    }
  },
  watch: {
    '$route.params.supervisorId': function () {
      this.getSupervisorDetail()
    }
  },
  mounted () {
    this.getSupervisorDetail()
    this.initCitySelect()
    this.initIndustrySelect()
    this.initUsers()
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    getSupervisorDetail () {
      Api.Supervisor.getSupervisorDetail(this.$route.params.supervisorId).then((res) => {
        Object.assign(this.supervisorModel, res)
        this.industryList = res.industries
        this.cityList = res.cities
        this.userList = res.users
        this.getSupervisionPermission()
      }).catch(err => {
        this.$Message.error('获取详情失败!' + err.message)
      })
    },
    async getSupervisionPermission () {
      await this.$Api.Supervisor.getSupervisorPermissions(this.$route.params.supervisorId)
      .then((res) => {
        this.supervisorRegionPermissions = res
      })
      .catch(() => {
        this.supervisorRegionPermissions = {
          canAuditGuarantor: false,
          canPreauditGuarantor: false,
          canBlacklistGuarantor: false,
          canClaim: false,
          canAddProjectRegister: false,
          canAuditProjectRegister: false,
          projectRegisterMode: null
        }
      })
    },
    editSupervisorRegion () {
      return new Promise((resolve, reject) => {
        Api.Supervisor.editSupervisorRegion({
          supervisorId: this.$route.params.supervisorId,
          regionId: 0,
          canPreauditGuarantor: this.supervisorRegionPermissions.canPreauditGuarantor,
          canAuditGuarantor: this.supervisorRegionPermissions.canAuditGuarantor,
          canBlacklistGuarantor: this.supervisorRegionPermissions.canBlacklistGuarantor,
          canClaim: this.supervisorRegionPermissions.canClaim,
          canAddProjectRegister: this.supervisorRegionPermissions.canAddProjectRegister,
          canAuditProjectRegister: this.supervisorRegionPermissions.canAuditProjectRegister,
          projectRegisterMode: this.supervisorRegionPermissions.projectRegisterMode
        }).then(() => {
          this.$Message.success('操作成功!')
          this.getSupervisionPermission()
          resolve()
        }).catch(err => {
          this.$Message.error('操作失败!' + err.message)
          reject()
        })
      })
    },
    initCitySelect () {
      Api.City.listCities({
        tier: 1,
        isVisible: null
      }, 1, 1000).then((cities) => {
        let data = cities.data.map((c) => {
          return {
            id: c.tid,
            value: c.tid,
            label: c.name,
            tier: c.tier,
            parent: c.parent,
            loading: false,
            children: []
          }
        })
        this.cities = data
      }).catch(err => {
        this.$Message.error('获取城市列表失败!' + err.message)
      })
    },
    loadCityData (item, callback) {
      item.loading = true
      let parentId = item.value
      let tier = item.tier || 0
      let curNode = null
      if (tier === 1) {
        curNode = this.cities.filter((c) => {
          return c.id === item.id
        })[0]
      } else {
        let parentNode = this.cities.filter((c) => {
          return c.id === item.parent
        })
        curNode = parentNode[0]
      }
      console.log(curNode)
      Api.City.listCities({
        tier: tier + 1,
        parentId: parentId,
        isVisible: null
      }, 1, 1000).then((cities) => {
        let data = cities.data.map((c) => {
          if (tier === 1) {
            return {
              id: c.tid,
              value: c.tid,
              label: c.name,
              tier: c.tier,
              parent: c.parent,
              loading: false,
              children: []
            }
          } else {
            return {
              value: c.tid,
              label: c.name,
              tier: c.tier,
              parent: c.parent
            }
          }
        })
        let retData = [{
          value: parentId,
          label: '本级'
        }]
        data.forEach((d) => {
          retData.push(d)
        })
        if (tier === 0) {
          curNode = retData
        } else {
          item.children = retData
        }
        item.loading = false
        callback()
      }).catch(err => {
        this.$Message.error('获取城市列表失败!' + err.message)
        item.loading = false
        callback()
      })
    },
    citySelected (val) {
      if (val instanceof Array) {
        this.newCityModel.cityId = val[val.length - 1]
      } else {
        this.newCityModel.cityId = val
      }
    },
    initIndustrySelect () {
      Api.Industry.listIndustries({
      }, 1, 1000).then((res) => {
        let data = res.data.map((c) => {
          return {
            id: c.id,
            value: c.id,
            label: c.name
          }
        })
        this.industries = data
      }).catch(err => {
        this.$Message.error('获取行业列表失败!' + err.message)
      })
    },
    addIndustry () {
      this.$refs.newIndustryForm.validate(async (valid) => {
        if (valid) {
          Api.Supervisor.addSupervisorToIndustry({
            supervisorId: this.$route.params.supervisorId,
            industryId: this.newIndustryModel.industryId,
            readOnly: this.newIndustryModel.readOnly,
            canPreAudit: this.newIndustryModel.canPreAudit,
            canAudit: this.newIndustryModel.canAudit,
            canAuditTerminate: this.newIndustryModel.canAuditTerminate,
            canAuditRenewal: this.newIndustryModel.canAuditRenewal,
            canClaim: this.newIndustryModel.canClaim,
            canAddProjectRegister: this.newIndustryModel.canAddProjectRegister,
            canAuditProjectRegister: this.newIndustryModel.canAuditProjectRegister
          }).then(() => {
            this.$Message.success('操作成功!')
            this.getSupervisorDetail()
          }).catch(err => {
            this.$Message.error('操作失败!' + err.message)
          })
        }
      })
    },
    editIndustry () {
      return new Promise((resolve, reject) => {
        Api.Supervisor.editSupervisorIndustry({
          supervisorId: this.$route.params.supervisorId,
          industryId: this.editIndustryModel.industryId,
          readOnly: this.editIndustryModel.readOnly,
          canPreAudit: this.editIndustryModel.canPreAudit,
          canAudit: this.editIndustryModel.canAudit,
          canAuditTerminate: this.editIndustryModel.canAuditTerminate,
          canAuditRenewal: this.editIndustryModel.canAuditRenewal,
          canClaim: this.editIndustryModel.canClaim,
          canAddProjectRegister: this.editIndustryModel.canAddProjectRegister,
          canAuditProjectRegister: this.editIndustryModel.canAuditProjectRegister
        }).then(() => {
          this.$Message.success('操作成功!')
          this.getSupervisorDetail()
          this.editIndustryModel = {
            supervisorId: this.$route.params.supervisorId,
            industryId: null,
            readOnly: null,
            canPreAudit: null,
            canAudit: null,
            canAuditTerminate: null,
            canAuditRenewal: null,
            canClaim: null,
            canAddProjectRegister: null,
            canAuditProjectRegister: null
          }
          resolve()
        }).catch(err => {
          this.$Message.error('操作失败!' + err.message)
          this.editIndustryModel = {
            supervisorId: this.$route.params.supervisorId,
            industryId: null,
            readOnly: null,
            canPreAudit: null,
            canAudit: null,
            canAuditTerminate: null,
            canAuditRenewal: null,
            canClaim: null,
            canAddProjectRegister: null,
            canAuditProjectRegister: null
          }
          reject()
        })
      })
    },
    removeIndustry (tid) {
      this.$Modal.confirm({
        title: '确认操作',
        content: '<p>确认删除该行业领域监管么？</p>',
        onOk: async () => {
          // this.$Spin.show()
          await Api.Supervisor.removeSupervisorFromIndustryById(tid).catch(err => {
            this.$Message.error('操作失败!' + err.message)
            return null
          })
          this.$Message.success('操作成功!')
          this.industryList.splice(
            this.industryList
            .findIndex(o => {return o.id === tid}), 1)
        },
        onCancel: () => {
        }
      })
    },
    addCity () {
      this.$refs.newCityForm.validate(async (valid) => {
        if (valid) {
          Api.Supervisor.addSupervisorToCity({
            supervisorId: this.$route.params.supervisorId,
            cityId: this.newCityModel.cityId,
            readOnly: this.newCityModel.readOnly,
            canPreAudit: this.newCityModel.canPreAudit,
            canAudit: this.newCityModel.canAudit,
            canAuditTerminate: this.newCityModel.canAuditTerminate,
            canAuditRenewal: this.newCityModel.canAuditRenewal,
            canClaim: this.newCityModel.canClaim,
            canAddProjectRegister: this.newCityModel.canAddProjectRegister,
            canAuditProjectRegister: this.newCityModel.canAuditProjectRegister
          }).then(() => {
            this.$Message.success('操作成功!')
            this.getSupervisorDetail()
          }).catch(err => {
            this.$Message.error('操作失败!' + err.message)
          })
        }
      })
    },
    editCity () {
      return new Promise((resolve, reject) => {
        Api.Supervisor.editSupervisorCity({
          supervisorId: this.$route.params.supervisorId,
          cityId: this.editCityModel.cityId,
          readOnly: this.editCityModel.readOnly,
          canPreAudit: this.editCityModel.canPreAudit,
          canAudit: this.editCityModel.canAudit,
          canAuditTerminate: this.editCityModel.canAuditTerminate,
          canAuditRenewal: this.editCityModel.canAuditRenewal,
          canClaim: this.editCityModel.canClaim,
          canAddProjectRegister: this.editCityModel.canAddProjectRegister,
          canAuditProjectRegister: this.editCityModel.canAuditProjectRegister
        }).then(() => {
          this.$Message.success('操作成功!')
          this.getSupervisorDetail()
          this.editCityModel = {
            supervisorId: this.$route.params.supervisorId,
            cityId: null,
            readOnly: null,
            canPreAudit: null,
            canAudit: null,
            canAuditTerminate: null,
            canAuditRenewal: null,
            canClaim: null,
            canAddProjectRegister: null,
            canAuditProjectRegister: null
          }
          resolve()
        }).catch(err => {
          this.$Message.error('操作失败!' + err.message)
          this.editCityModel = {
            supervisorId: this.$route.params.supervisorId,
            cityId: null,
            readOnly: null,
            canPreAudit: null,
            canAudit: null,
            canAuditTerminate: null,
            canAuditRenewal: null,
            canClaim: null,
            canAddProjectRegister: null,
            canAuditProjectRegister: null
          }
          reject()
        })
      })
    },
    removeCity (tid) {
      this.$Modal.confirm({
        title: '确认操作',
        content: '<p>确认删除该区域监管么？</p>',
        onOk: async () => {
          // this.$Spin.show()
          await Api.Supervisor.removeSupervisorFromCityById(tid).catch(err => {
            this.$Message.error('操作失败!' + err.message)
            return null
          })
          this.$Message.success('操作成功!')
          this.cityList.splice(
            this.cityList
            .findIndex(o => {return o.id === tid}), 1)
        },
        onCancel: () => {
        }
      })
    },
    initUsers () {
      Api.Auth(this).listUsersByType(5).then((res) => {
        let data = res.data.map((c) => {
          return {
            id: c.id,
            value: c.id,
            label: `${c.displayName}(${c.loginName})`
          }
        })
        this.users = data
      }).catch(err => {
        this.$Message.error('获取用户列表失败!' + err.message)
      })
    },
    addUser () {
      this.$refs.newUserForm.validate(async (valid) => {
        if (valid) {
          Api.Supervisor.addUesrToSupervisor(
            this.$route.params.supervisorId,
            this.newUserModel.userId,
            this.newUserModel.isAdmin
          ).then(() => {
            this.$Message.success('操作成功!')
            this.getSupervisorDetail()
          }).catch(err => {
            this.$Message.error('操作失败!' + err.message)
          })
        }
      })
    },
    removeUser (userId) {
      this.$Modal.confirm({
        title: '确认操作',
        content: '<p>确认删除该管理用户么？</p>',
        onOk: async () => {
          // this.$Spin.show()
          await Api.Supervisor.removeUesrFromSupervisor(this.$route.params.supervisorId, userId).catch(err => {
            this.$Message.error('操作失败!' + err.message)
            return null
          })
          this.$Message.success('操作成功!')
          this.userList.splice(
            this.userList
            .findIndex(o => {return o.user.id === userId}), 1)
        },
        onCancel: () => {
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.detail-header {
  margin-bottom: 20px;
}
td.title {
  width: 140px;
}
</style>
